import { Link } from "react-router-dom";

const ENTRIES = [
  {
    to: "/category/movie",
    icon: "ri-movie-2-line",
    title: "电影频道",
    desc: "剧情、家庭、悬疑、科幻等多种电影类型合集",
    count: "12 部",
    tone: "bg-primary-500 text-background-50",
  },
  {
    to: "/category/tv",
    icon: "ri-tv-2-line",
    title: "电视剧频道",
    desc: "都市、家庭、古装、悬疑热播剧集一网打尽",
    count: "6 部",
    tone: "bg-secondary-500 text-background-50",
  },
  {
    to: "/category/topic",
    icon: "ri-heart-3-line",
    title: "主题专题",
    desc: "聚焦“年轻的母亲”等温暖情感主题的内容合辑",
    count: "8 部",
    tone: "bg-accent-500 text-foreground-950",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {ENTRIES.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group relative overflow-hidden rounded-lg bg-background-100 border border-background-200 p-5 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <span
            className={`w-11 h-11 rounded-lg flex items-center justify-center ${entry.tone}`}
          >
            <i className={`${entry.icon} text-xl`}></i>
          </span>
          <h3 className="mt-4 font-heading font-bold text-base text-foreground-950 group-hover:text-primary-600 transition-colors">
            {entry.title}
          </h3>
          <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">
            {entry.desc}
          </p>
          <div className="mt-3 flex items-center justify-between">
            <span className="text-xs text-secondary-700 bg-secondary-100 px-2 py-0.5 rounded">
              {entry.count}
            </span>
            <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-1 transition-all"></i>
          </div>
        </Link>
      ))}
    </div>
  );
}